"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  premium: {
    id: "window.billing.tab.premium",
    defaultMessage: "PREMIUM",
    description: ""
  },
  buff: {
    id: "window.billing.tab.buff",
    defaultMessage: "BUFF",
    description: ""
  },
  transformation: {
    id: "window.billing.tab.transformation",
    defaultMessage: "TRANSFORMATION",
    description: ""
  },
  powerUp: {
    id: "window.billing.tab.powerUp",
    defaultMessage: "POWER UP",
    description: ""
  },
  herrny: {
    id: "window.billing.herrny",
    defaultMessage: "Herrny",
    description: ""
  },
  quantity: {
    id: "window.billing.quantity",
    defaultMessage: "Quantity",
    description: ""
  },
  cashAmount: {
    id: "window.billing.cashAmount",
    defaultMessage: "CASH AMOUNT",
    description: ""
  },
  voucher: {
    id: "window.billing.voucher",
    defaultMessage: "VOUCHER",
    description: ""
  },
  purchase: {
    id: "window.billing.button.purchase",
    defaultMessage: "PURCHASE",
    description: ""
  },
  purchaseL: {
    id: "window.billing.button.purchaseL",
    defaultMessage: "PURCHASE L",
    description: ""
  },
  charge: {
    id: "window.billing.button.charge",
    defaultMessage: "CHARGE",
    description: ""
  }
});

exports.default = _default;